export default __webpack_public_path__ + "static/lab_equipment_upgrade-ed3a1080189b39d3bffd04d668104dfe.png";